import * as React from 'react'
import { Flex } from '@radix-ui/themes'
import { styles } from './styles.css'
import image1 from './images/1.jpg'
import image2 from './images/2.jpg'
import image3 from './images/3.jpg'
import image4 from './images/4.jpg'
import otoku from './images/otoku.svg'

export const SummarySection: React.FC = () => {
  return (
    <Flex direction="column" align="center" width="100%" className={styles.section}>
      <Flex direction="column" align="center" width="100%" gap="32px" py="40px">
        <h2 className={styles.headline}>
          かわいい花を
          <br />
          どこよりもお得に。
        </h2>
        <Flex direction="column" align="center" width="100%">
          <p className={styles.text}>
            そんな想いからはじまり
            <br />
            累計販売数100万ブーケを突破した
            <br />
            アプリのお花屋さん「FLOWER」が
            <br />
            花の定期便を作りました！
          </p>
        </Flex>
      </Flex>
      <div className={styles.carousel}>
        <div className={styles.images}>
          <img className={styles.image} src={image1} />
          <img className={styles.image} src={image2} />
          <img className={styles.image} src={image3} />
          <img className={styles.image} src={image4} />
          <img className={styles.image} src={image1} />
          <img className={styles.image} src={image2} />
          <img className={styles.image} src={image3} />
          <img className={styles.image} src={image4} />
        </div>
      </div>
      <Flex direction="column" align="center" width="100%" gap="8px" mt="30px" pt="24px" px="24px">
        <Flex direction="row" align="center" justify="center" gap="8px" px="24px">
          <div className={styles.otoku}>
            <img src={otoku} className={styles.otokuBackground} />
            <Flex direction="column" align="center" justify="center" height="98%" width="100%" pl="2px">
              <Flex direction="row" align="baseline">
                <span style={{ fontWeight: '900', fontSize: '22.5px' }}>20</span>
                <span style={{ fontWeight: '900', fontSize: '12px' }}>%</span>
              </Flex>
              <span>お得</span>
            </Flex>
          </div>
          <Flex direction="column" align="start">
            <p className={styles.priceText}>
              約12本、<strong>参考価格3,800円相当</strong>の<br />
              お花が入って
            </p>
            <p className={styles.price}>
              <span>月額</span>&nbsp;
              <strong style={{ fontSize: '28px', fontWeight: '700' }}>2,970</strong>
              <span style={{ fontSize: '18px', letterSpacing: '-0.21em' }}>円</span>
              <span>（送料無料）</span>
            </p>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}
